import React from 'react'

import ContentWrapper from '../components/ContentWrapper'
import OnboardingDocumentsForm from '../components/OnboardingDocumentsForm'
import Txt from '../components/Txt'
import { useCurrentUser } from '../utils/user'

// Die Onboarding-Dokumente blanko für den Root, zum Ausfüllen von Hand bei einem Restaurant, das noch
// nicht angelegt ist.
const DocumentsView = (): JSX.Element => {
	const { data: currentUser } = useCurrentUser()
	return (
		<ContentWrapper p="1rem">
			{currentUser?.isRoot ? (
				<>
					<Txt variant="h6" fontWeight="bold">
						Dokumente blanko
					</Txt>
					<OnboardingDocumentsForm blank />
				</>
			) : null}
		</ContentWrapper>
	)
}

export default DocumentsView
